import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:26
* @route '/produit'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/produit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:26
* @route '/produit'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:26
* @route '/produit'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:26
* @route '/produit'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:26
* @route '/produit'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:26
* @route '/produit'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:26
* @route '/produit'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\PublicController::instances
* @see app/Http/Controllers/PublicController.php:31
* @route '/produit/instances-whatsapp'
*/
export const instances = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: instances.url(options),
    method: 'get',
})

instances.definition = {
    methods: ["get","head"],
    url: '/produit/instances-whatsapp',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::instances
* @see app/Http/Controllers/PublicController.php:31
* @route '/produit/instances-whatsapp'
*/
instances.url = (options?: RouteQueryOptions) => {
    return instances.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::instances
* @see app/Http/Controllers/PublicController.php:31
* @route '/produit/instances-whatsapp'
*/
instances.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: instances.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::instances
* @see app/Http/Controllers/PublicController.php:31
* @route '/produit/instances-whatsapp'
*/
instances.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: instances.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::instances
* @see app/Http/Controllers/PublicController.php:31
* @route '/produit/instances-whatsapp'
*/
const instancesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: instances.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::instances
* @see app/Http/Controllers/PublicController.php:31
* @route '/produit/instances-whatsapp'
*/
instancesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: instances.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::instances
* @see app/Http/Controllers/PublicController.php:31
* @route '/produit/instances-whatsapp'
*/
instancesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: instances.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

instances.form = instancesForm

/**
* @see \App\Http\Controllers\PublicController::validation
* @see app/Http/Controllers/PublicController.php:36
* @route '/produit/validation-numeros'
*/
export const validation = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: validation.url(options),
    method: 'get',
})

validation.definition = {
    methods: ["get","head"],
    url: '/produit/validation-numeros',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::validation
* @see app/Http/Controllers/PublicController.php:36
* @route '/produit/validation-numeros'
*/
validation.url = (options?: RouteQueryOptions) => {
    return validation.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::validation
* @see app/Http/Controllers/PublicController.php:36
* @route '/produit/validation-numeros'
*/
validation.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: validation.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::validation
* @see app/Http/Controllers/PublicController.php:36
* @route '/produit/validation-numeros'
*/
validation.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: validation.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::validation
* @see app/Http/Controllers/PublicController.php:36
* @route '/produit/validation-numeros'
*/
const validationForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: validation.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::validation
* @see app/Http/Controllers/PublicController.php:36
* @route '/produit/validation-numeros'
*/
validationForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: validation.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::validation
* @see app/Http/Controllers/PublicController.php:36
* @route '/produit/validation-numeros'
*/
validationForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: validation.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

validation.form = validationForm

/**
* @see \App\Http\Controllers\PublicController::messages
* @see app/Http/Controllers/PublicController.php:41
* @route '/produit/messages'
*/
export const messages = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: messages.url(options),
    method: 'get',
})

messages.definition = {
    methods: ["get","head"],
    url: '/produit/messages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::messages
* @see app/Http/Controllers/PublicController.php:41
* @route '/produit/messages'
*/
messages.url = (options?: RouteQueryOptions) => {
    return messages.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::messages
* @see app/Http/Controllers/PublicController.php:41
* @route '/produit/messages'
*/
messages.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: messages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::messages
* @see app/Http/Controllers/PublicController.php:41
* @route '/produit/messages'
*/
messages.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: messages.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::messages
* @see app/Http/Controllers/PublicController.php:41
* @route '/produit/messages'
*/
const messagesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: messages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::messages
* @see app/Http/Controllers/PublicController.php:41
* @route '/produit/messages'
*/
messagesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: messages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::messages
* @see app/Http/Controllers/PublicController.php:41
* @route '/produit/messages'
*/
messagesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: messages.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

messages.form = messagesForm

/**
* @see \App\Http\Controllers\PublicController::templates
* @see app/Http/Controllers/PublicController.php:46
* @route '/produit/templates-dynamiques'
*/
export const templates = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: templates.url(options),
    method: 'get',
})

templates.definition = {
    methods: ["get","head"],
    url: '/produit/templates-dynamiques',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::templates
* @see app/Http/Controllers/PublicController.php:46
* @route '/produit/templates-dynamiques'
*/
templates.url = (options?: RouteQueryOptions) => {
    return templates.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::templates
* @see app/Http/Controllers/PublicController.php:46
* @route '/produit/templates-dynamiques'
*/
templates.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: templates.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::templates
* @see app/Http/Controllers/PublicController.php:46
* @route '/produit/templates-dynamiques'
*/
templates.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: templates.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::templates
* @see app/Http/Controllers/PublicController.php:46
* @route '/produit/templates-dynamiques'
*/
const templatesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: templates.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::templates
* @see app/Http/Controllers/PublicController.php:46
* @route '/produit/templates-dynamiques'
*/
templatesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: templates.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::templates
* @see app/Http/Controllers/PublicController.php:46
* @route '/produit/templates-dynamiques'
*/
templatesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: templates.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

templates.form = templatesForm

/**
* @see \App\Http\Controllers\PublicController::campaigns
* @see app/Http/Controllers/PublicController.php:51
* @route '/produit/campagnes'
*/
export const campaigns = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: campaigns.url(options),
    method: 'get',
})

campaigns.definition = {
    methods: ["get","head"],
    url: '/produit/campagnes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::campaigns
* @see app/Http/Controllers/PublicController.php:51
* @route '/produit/campagnes'
*/
campaigns.url = (options?: RouteQueryOptions) => {
    return campaigns.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::campaigns
* @see app/Http/Controllers/PublicController.php:51
* @route '/produit/campagnes'
*/
campaigns.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: campaigns.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::campaigns
* @see app/Http/Controllers/PublicController.php:51
* @route '/produit/campagnes'
*/
campaigns.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: campaigns.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::campaigns
* @see app/Http/Controllers/PublicController.php:51
* @route '/produit/campagnes'
*/
const campaignsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: campaigns.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::campaigns
* @see app/Http/Controllers/PublicController.php:51
* @route '/produit/campagnes'
*/
campaignsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: campaigns.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::campaigns
* @see app/Http/Controllers/PublicController.php:51
* @route '/produit/campagnes'
*/
campaignsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: campaigns.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

campaigns.form = campaignsForm

const product = {
    index: Object.assign(index, index),
    instances: Object.assign(instances, instances),
    validation: Object.assign(validation, validation),
    messages: Object.assign(messages, messages),
    templates: Object.assign(templates, templates),
    campaigns: Object.assign(campaigns, campaigns),
}

export default product